import React from "react";
import { useNavigate } from 'react-router-dom';

export default function GameModeButton({ title, icon, description, url, color }){
    const navigate = useNavigate();
  
    function navigateTo(){
        navigate(url);
    }

    return(
        <div className={`gamemode-component border-${color}`}>
            {icon}
            <h2>{title}</h2>
            <p className="gamemode-description">{description}</p>
            <button className={`gamemode-button gamemode-button-${color}`} onClick={navigateTo}>Play {">"}</button>
        </div>
    )
}